import { Sidebar } from "primereact/sidebar";
import Container from "./Container";
import FormField from "./FormField";
import { Button } from "primereact/button";
import { useForgotPassword } from "../contexts/ForgotPasswordContext";
import { Message } from "primereact/message";
import { emailRegex } from "../helpers/regex";
import { InputOtp } from 'primereact/inputotp';
import Label from "./Label";
import { Toast } from "primereact/toast";

export default function ForgotPasswordSidebar() {
    const context = useForgotPassword();
    
    return (
        <>
            <Toast ref={context?.toast} />
            <Sidebar 
                visible={context?.isOpen} 
                position="bottom"
                style={{ height: "30rem" }}
                onHide={() => context?.close()}
            >
                <Container center fullWidth>
                    <Container center flexColumn maxWidth={500} gap={3} fullWidth>
                        <h2>Recuperar senha</h2>

                        {
                            context?.showChangePassword
                                ? (
                                    <>
                                        <FormField 
                                            label="Nova senha" 
                                            id="passwordForgot" 
                                            type="password"
                                            value={context?.password}
                                            setValue={(password) => context?.changePassword(password)}
                                            withoutFormikContext
                                        />

                                        <Container flexColumn fullWidth marginVertical="3">
                                            <Label className="mb-2" htmlFor="code">Código</Label>
                                            <InputOtp 
                                                id="code"
                                                value={context.code}
                                                length={6} 
                                                onChange={(e) => context.changeCode(e.value?.toString() ?? "")}
                                            />
                                        </Container>
            
                                        <Button 
                                            label={context?.isLoading ? "Alterando senha..." : "Alterar senha"}
                                            type="button"
                                            disabled={!context.password || (!context.code || context.code.length < 6) || context.isLoading}
                                            onClick={() => context?.requestChangePassword()} 
                                            loading={context?.isLoading}
                                            className="bg-primary w-full" 
                                        />
                                    </>
                                )
                                : (
                                    <>
                                        <FormField 
                                            label="Endereço de Email" 
                                            id="email" 
                                            type="email"
                                            value={context?.email}
                                            setValue={(email) => context?.changeEmail(email)}
                                            withoutFormikContext
                                        />

                                        <Button 
                                            label={context?.isLoading ? "Enviando email..." : "Enviar email de recuperação"}
                                            type="button"
                                            disabled={!context?.email || !context.email.match(emailRegex) || context.isLoading}
                                            onClick={() => context?.requestForgot()} 
                                            loading={context?.isLoading}
                                            className="bg-primary w-full" 
                                        />
                                    </>
                                )
                        }

                        {
                            context?.errorMessage && <Message className="mt-2 w-full" severity="error" text={context.errorMessage} />
                        }
                    </Container>
                </Container>
            </Sidebar>
        </>
    )
}
